class Top_swiper {
  constructor(public Swiper: any) {
    this.Swiper = Swiper
  }
  public main() {
    const Swiper = this.Swiper
    let swiper_feature_btmElement: any = document.getElementsByClassName(
      'swiper-container--mainthumb'
    )[0]
    let swiper_feature_btm: any
    let swiper_btmElement = swiper_feature_btmElement.querySelectorAll(
      '.swiper-slide'
    )
    let slide_len = swiper_btmElement.length

    let swiper_play = function() {
      const mv_swiper = new Swiper('.swiper-container--main', {
        loop: true,
        preventClicks: false,
        preventClicksPropagation: false,
        disableOnInteraction: false,
        loopedSlides: slide_len,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })

      let bool_device = window.innerWidth <= 500 ? false : true

      let slide_style = function() {
        if (bool_device === true) {
          let slide_m = slide_len * 10
          let slide_w = slide_len * 200
          swiper_feature_btmElement.style.width = slide_m + slide_w + 'px'
        }
      }

      let option = {
        preventClicks: false,
        preventClicksPropagation: false,
        centeredSlides: true,
        loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        disableOnInteraction: false,
        speed: 600,
        slidesPerView: slide_len,
        spaceBetween: 12,
        freeMode: false,
        loopedSlides: slide_len,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        updateOnImagesReady: true,
        controller: {
          control: mv_swiper,
          inverse: false,
          by: 'slide'
        }
      }

      if (bool_device === false) {
        option.slidesPerView = 3
        swiper_feature_btm = new Swiper(swiper_feature_btmElement, option)
      } else {
        slide_style()
        swiper_feature_btm = new Swiper(swiper_feature_btmElement, option)
        swiper_feature_btm.on('touchStart', function() {
          swiper_feature_btm.autoplay.stop()
        })
        swiper_feature_btm.on('slideChange', function() {
          swiper_feature_btm.autoplay.start()
        })
      }

      mv_swiper.controller.control = swiper_feature_btm
      swiper_feature_btm.controller.control = mv_swiper

      if (window.innerWidth <= 500) {
        new Swiper('.swiper-container--casestudy', {
          loop: true,
          pagination: {
            el: '.casestudy-my-pagination',
            clickable: true
          }
        })
      } else {
        return
      }
    }

    swiper_play()
  }
}
export default Top_swiper
